import { createSelector } from '@ngrx/store'

import * as user from '../actions/user'
import * as auth from '../actions/auth.actions'

import { UserContext } from '../models/auth'

export interface State {
    error: any
    loading: boolean
    context: UserContext | null
    customerSelected: string
}

const initialState: State = {
    error: null,
    loading: false,
    context: null,
    customerSelected: null
}

export function reducer(
    state = initialState,
    action: user.Actions | auth.Actions
) {
    switch(action.type) {
        case user.GET:
            return {
                ...state,
                loading: true
            }

        case user.GET_SUCCESS:
            return {
                ...state,
                context: action.payload,
                loading: false
            }

        case user.GET_FAILED:
            return {
                ...state,
                error: action.payload,
                loading: false
            }

        case user.SET_SUCCESS:
            return {
                ...state,
                context: {
                    ...state.context,
                    preferences: action.payload
                }
            }

        case user.SET_FAILED:
            return {
                ...state,
                error: action.payload
            }

      case user.SELECT_CUSTOMER:
        return {
          ...state,
          customerSelected: '',
          context: {
            ...state.context,
            customer: {}
          }
        }

        case user.SET_CUSTOMER:
            return {
              ...state,
              customerSelected: action.payload
            }

      case user.SET_CUSTOMER_SUCCESS:
        return {
          ...state,
          context: {...state.context, customer: action.payload}
        }

      case user.SET_CUSTOMER_FAILED:
        return {
          ...state,
          error: action.payload
        }

        case auth.LOGOUT:
            return initialState

        default:
            return state
    }
}
export const getUserState = (state: State) => state
export const getUserContext = (state: State) => state.context
export const getError = (state: State) => state.error
export const isLoading = (state: State) => state.loading

export const getAddresses = createSelector(
    getUserContext,
    user => (user && user.customer && user.customer.addresses) || []
)
export const getCustomerCurrency = createSelector(
    getUserContext,
    user => (user && user.customer && user.customer.currency) || 'EUR'
)
export const getLanguage = createSelector(
    getUserContext,
    context => context && context.preferences && context.preferences.language
)

export const getUserId = createSelector(
  getUserContext,
  context => context && context._id
)

export const getCustomerInfo = createSelector(
  getUserContext,
  context => context && context.customer
)
export const getCurrentTenant = createSelector(
  getUserContext,
  context => context && context.tenantName
)
export const getCustomerId = createSelector(
  getCustomerInfo,
  customer => customer && customer._id
)
export const getCustomerMinOrderValue = createSelector(
  getCustomerInfo,
  customer => customer && customer.minOrderValue
)
export const getCustomerDiscounts = createSelector(
  getCustomerInfo,
  customer => customer && customer.discounts
)
export const getUserPermissions = createSelector(
  getUserContext,
  context => context && context.permissions
)
